// Design tokens - Colors, Typography, Spacing, Border Radius
export const colors = {
  primary: '#0b2a5e',
  accent: '#c2cce3',
  active: '#5f9ea0',
  background: '#ffffff',
  backgroundLight: '#ffffff',
  backgroundDark: '#112120',
  contentLight: '#112120',
  contentDark: '#f6f8f8',
  textPrimary: '#000000',
  textSecondary: '#5f9ea0',
  textLight: '#112120',
  textDark: '#f6f8f8',
  inputLight: '#f0f0f0',
  inputDark: '#223130',
  subtleLight: '#e5e7eb',
  subtleDark: '#374151',
  borderLight: '#E5E7EB',
  borderDark: '#374151',
  header: '#f86d72',
  white: '#ffffff',
  black: '#000000',
  gray50: '#f9fafb',
  gray100: '#f3f4f6',
  gray200: '#e5e7eb',
  gray300: '#d1d5db',
  gray400: '#9ca3af',
  gray500: '#6b7280',
  gray600: '#4b5563',
  gray700: '#374151',
  gray800: '#1f2937',
};

export const typography = {
  display: "'Outfit', system-ui, sans-serif",
  regular: "'Outfit', system-ui, sans-serif",
};

export const spacing = {
  xs: '4px',
  sm: '8px',
  md: '16px',
  lg: '24px',
  xl: '32px',
  xxl: '48px',
};

export const borderRadius = {
  sm: '8px',
  md: '12px',
  lg: '16px',
  xl: '20px',
  full: '9999px',
};


